<template>
    <div>
        <div class="row">
            <div class="col-5">
                <b>{{ question }}</b>
            </div>
            <div class="col-7">
                <ValidationProvider
                  v-slot="{ errors, validated }"
                  rules="required"
                >
                    <CustomRadioButtonGroup
                        v-model="model.answer"
                        :options="options"
                        :disabled="disabled"
                        :has-error="validated && !!errors.length"
                        error-message="Al menos una opción es requerida"
                    />
                </ValidationProvider>
            </div>
        </div>
        <div v-if="isCommentRequired">
            <ValidationProvider
                v-slot="{ errors }"
                rules="required"
            >
                <CustomTextArea
                    v-model="model.comment"
                    :disabled="disabled"
                    label="Indique el nombre de la escuela desde la cual se trasladó el equipo:"
                    placeholder="Comentario"
                    :rows="2"
                    :maxlength="3000"
                    class="my-4"
                    :error="errors[0]"
                    custom-error-msg="Comentario es requerido"
                />
            </ValidationProvider>
        </div>
    </div>
</template>
<script>
import CustomTextArea from 'CustomTextArea';
import { ValidationProvider } from "vee-validate";
import CustomRadioButtonGroup from "@/views/pei/atEquipment/common/CustomRadioButtonGroup.vue";

const OPTION_REQUIRE_COMMENT = 'yes';

export default {  
    name: "FromOtherSchoolQuestion",
    components: {
        CustomTextArea,
        ValidationProvider,
        CustomRadioButtonGroup
    },
    props: {
        value: {
            type: Object,
            required: true,
            default: () => ({
                answer: "",
                comment: "",
            }),
        },
        question: {
            type: String,
            required: true,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data: () => ({
        model: {
            answer: "",
            comment: "",
        },
        options: [
            { label: 'Sí', value: OPTION_REQUIRE_COMMENT },
            { label: 'No', value: 'no' },
        ]
    }),
    computed: {
        isCommentRequired() {
            return this.model.answer == OPTION_REQUIRE_COMMENT;
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.model.answer = newValue.answer;
                this.model.comment = newValue.comment;
            }
        },
        model: {
            deep: true,
            handler(newValue) {
                this.$emit('input', newValue);
            }
        },
    },
};
</script>

<style scoped>
</style>